import DashboardIva from "../../components/DashboardIva";

const DashboardIvaPage = () => <DashboardIva />;

export default DashboardIvaPage;
